import React, { Component, Fragment } from 'react'
import gql from 'graphql-tag'
import { withApollo } from 'react-apollo'
import getLoginId from '../../../utils/getLoginId'
import Select from 'react-select'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import PropTypes from 'prop-types'
import moment from 'moment'
import { DatePicker } from 'material-ui-pickers'
import MUIDataTable, { createMuiTheme, ThemeProvider } from 'mui-datatables'
import {
  withStyles,
  Button,
  Grid,
  TextField,
  Typography
} from '@material-ui/core'
import zIndex from '@material-ui/core/styles/zIndex'

// noDataInMinutes -  Needs to brainstrom and add this in schema
const GET_DEVICE_REPORT = gql`
query getLatestVehicleAnalyticData($clientLoginId: Int, $from_ts: String, $to_ts: String) {
  getLatestVehicleAnalyticData(clientLoginId: $clientLoginId, from_ts: $from_ts, to_ts: $to_ts) {
    vehicleNumber
    Date
    UniqueId
    TotalNumberofPackets
    IgOnTrackingPackets
    IgOffTrackingPackets
    IgONInterval
    IgOFFInterval
    IgnitionONDataLossTime
    IgnitionONDataLoss
    IgnitionOFFDataLossTime
    IgnitionOFFDataLoss
    TotalIgnitionONTime
    TotalIgnitionOffTime
    MainPowerConnectedPackets
    MainPowerDisconnectedPackets
    LivePacketsCount
    LivePacket
    GPSValidDataCount
    GPSInvalidDataCount
    ValidData
    InvalidwithIgnitionOn
    InvalidwithIgnitionOff
    HistoryPacketsCount 
    __typename
  }
}
`

const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int) {
    clients: allClientDetails(partnerLoginId: $partnerLoginId) {
      id
      clientName
      loginId
    }
  }
`

const today = new Date()
today.setDate(today.getDate() - 1);

const style = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing.unit * 4,
    flexGrow: 1
  },
  formControl: {
    margin: theme.spacing.unit * 3
  },
  textField: {
    width: 200,
  },
  muiStyle: {
    marginTop: theme.spacing.unit * 4
  },
  errorMsg: {
    marginTop: theme.spacing.unit * 4
  }
})

class DeviceDataKpi extends Component {
  state = {
    enableSubmit: false,
    loading: false,
    responseStatus: "Loading...",
    selectedDate: '',
    selectedFromDate: '',
    selectedToDate: '',
    clientNameInfo: [],
    clientNames: [],
    clientLoginId: '',
    clientName: '',
    selectedDateForformat: null,
    selectedDateToformat: null,
    errorMsgDisplay: false
  }
  columns = [
    'vehicleNumber',
    'Date',
    'UniqueId',
    'TotalNumberofPackets',
    'IgOnTrackingPackets',
    'IgOffTrackingPackets',
    'IgONInterval',
    'IgOFFInterval',
    'IgnitionONDataLossTime',
    'IgnitionONDataLoss (%)',
    'IgnitionOFFDataLossTime',
    'IgnitionOFFDataLoss (%)',
    'TotalIgnitionONTime',
    'TotalIgnitionOffTime',
    'MainPowerConnectedPackets',
    'MainPowerDisconnectedPackets',
    'LivePacketsCount',
    'LivePacket (%)',
    'GPSValidDataCount',
    'GPSInvalidDataCount',
    'ValidData (%)',
    'InvalidwithIgnitionOn',
    'InvalidwithIgnitionOff',
    'HistoryPacketsCount',
  ]

  options = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 15,
    headerStyle: {
      zIndex: -1
    }
  }

  fromDateChange = (e) => {
    let unixTimestamp = moment(e, 'YYYY-MM-DD').startOf('day').unix()
    let unixToString = unixTimestamp.toString()
    this.setState({ selectedDateForformat: e })
    this.setState({ selectedFromDate: unixToString })
  }

  toDateChange = (e) => {
    let unixTimestamp = moment(e, 'YYYY-MM-DD').startOf('day').unix()
    let unixToString = unixTimestamp.toString()
    this.setState({ selectedDateToformat: e })
    this.setState({ selectedToDate: unixToString })
  }
  getFormattedDate = timestamp =>
    moment(timestamp * 1000).format('DD-MM-YYYY')

  handleSubmit = async () => {
    this.setState({ loading: true, errorMsgDisplay: false })
    const getVehicleReport = await this.props.client.query({
      query: GET_DEVICE_REPORT,
      variables: {
        clientLoginId: this.state.clientLoginId,
        from_ts: this.state.selectedFromDate,
        to_ts: this.state.selectedToDate
      },
      // fetchPolicy: 'network-only'
    })
    getVehicleReport && this.setState({ loading: false })
    if (getVehicleReport.data.getLatestVehicleAnalyticData && getVehicleReport.data) {
      let vehicleDetails = getVehicleReport.data.getLatestVehicleAnalyticData;
      let data = []
      let rowData = []
      vehicleDetails.forEach((element) => {
        rowData = []
        rowData.push(element.vehicleNumber)
        rowData.push(this.getFormattedDate(element.Date))
        rowData.push(element.UniqueId)
        rowData.push(element.TotalNumberofPackets)
        rowData.push(element.IgOnTrackingPackets)
        rowData.push(element.IgOffTrackingPackets)
        rowData.push(element.IgONInterval)
        rowData.push(element.IgOFFInterval)
        rowData.push(element.IgnitionONDataLossTime)
        rowData.push(element.IgnitionONDataLoss)
        rowData.push(element.IgnitionOFFDataLossTime)
        rowData.push(element.IgnitionOFFDataLoss)
        rowData.push(element.TotalIgnitionONTime)
        rowData.push(element.TotalIgnitionOffTime)
        rowData.push(element.MainPowerConnectedPackets)
        rowData.push(element.MainPowerDisconnectedPackets)
        rowData.push(element.LivePacketsCount)
        rowData.push(element.LivePacket)
        rowData.push(element.GPSValidDataCount)
        rowData.push(element.GPSInvalidDataCount)
        rowData.push(element.ValidData)
        rowData.push(element.InvalidwithIgnitionOn)
        rowData.push(element.InvalidwithIgnitionOff)
        rowData.push(element.HistoryPacketsCount)
        data.push(rowData)
      })
      if (data.length > 1) {
        // let result = vehicleDetails.map(obj => Object.values(obj));
        this.setState({ fullData: data })
      } else {
        this.props.openSnackbar('No records found')
        this.setState({ fullData: [] })
      }
    } else {
      this.props.openSnackbar('No records found')
      this.setState({ fullData: [] })
    }
    if (this.state.selectedFromDate > this.state.selectedToDate) {
      this.props.openSnackbar('Please Select Valid Dates')
    }
  }

  getAllCustomers = async () => {
    const customers = await this.props.client.query({
      query: GET_CLIENTS,
      variables: {
        partnerLoginId: getLoginId()
      },
      fetchPolicy: 'network-only'
    })
    if (customers && customers.data) {
      var clientName = []
      var clientLoginId = []
      customers.data.clients.forEach(element => {
        clientName.push(element.clientName)
        clientLoginId.push(element.loginId)
      })
      this.setState({
        clientNameInfo: clientName,
        clientLoginIdInfo: clientLoginId
      })
      const allClients = customers.data.clients.map(client => ({
        value: client.loginId,
        label: client.clientName
      }))
      this.setState({ clientNames: allClients })
    }
  }

  handleChange = event => {
    if (event == null) {
      this.setState({ fullData: [], selectedDateUnformat: null, errorMsgDisplay: false })
    }
    this.setState(
      {
        clientName: event == null ? '' : event.label,
        clientLoginId: event == null ? '' : event.value
      }
    )
  }

  componentDidMount() {
    this.getAllCustomers()
  }

  // new ends
  render() {
    const { classes } = this.props
    const { spacing, selected, rowsPerPage, page } = this.state
    // console.log("Error Msg Displlay", this.state.errorMsgDisplay)
    return (
      <Fragment>
        <div className={classes.root}>
          <h3>Device Health Report</h3>
          <Grid
            container
            spacing={16}
            xs={12}
            style={{ width: '100%' }}
          >
            <Grid item xs={3} style={{ zIndex: '1000' }} >
              <Select
                style={{ alignItems: 'center', width: '85%' }}
                options={this.state.clientNames}
                value={this.state.clientLoginId}
                onChange={this.handleChange}
                placeholder="Select Customer"
              />
            </Grid>
            <Grid item xs={3}>
              <DatePicker
                value={this.state.selectedDateForformat}
                onChange={this.fromDateChange}
                format="DD/MM/YYYY"
                label='Select a Date'
                maxDate={today}
              />
            </Grid>
            <Grid item xs={3} >
              <DatePicker
                value={this.state.selectedDateToformat}
                onChange={this.toDateChange}
                format="DD/MM/YYYY"
                label='Select a Date'
                maxDate={today}
              />
            </Grid>
            <Grid item xs={3} >
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                className="btn"
                type="button"
                onClick={() => this.handleSubmit()}
                disabled={
                  this.state.selectedFromDate == '' ||
                  this.state.selectedToDate == '' ||
                  this.state.clientLoginId == ''
                }
              >
                Submit
              </Button>
            </Grid>

            {this.state.loading && (
              <p>
                {this.state.responseStatus}
              </p>
            )}
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              {this.state.errorMsgDisplay &&
                (
                  <Grid container className={classes.errorMsg}>
                    <Grid item>
                      <Typography variant="h3" color='error' >No Data Available</Typography>
                    </Grid>
                  </Grid>
                )
              }
              <Grid container className={classes.muiStyle}>
                <Grid item xs={12}>
                  <MUIDataTable
                    title={'Device Health Report'}
                    data={this.state.fullData}
                    columns={this.columns}
                    options={this.options}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Fragment >
    )
  }
}
DeviceDataKpi.propTypes = {
  classes: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired
}

export default withStyles(style)(
  withApollo(withSharedSnackbar(DeviceDataKpi))
)



// WEBPACK FOOTER //
// ./src/components/Pages/DeviceDataKpi/index.jsx